import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataTypeComponent } from '../../data-type-component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PersonalMonthlyNetLossThresholdService } from './personal-monthly-net-loss-threshold.service';
import { Action } from './personal-monthly-net-loss-threshold.model';

@Component({
  selector: 'app-personal-monthly-net-loss-threshold',
  templateUrl: './personal-monthly-net-loss-threshold.html',
  styleUrls: ['./personal-monthly-net-loss-threshold.component.scss'],
  standalone: false,
})
export class PersonalMonthlyNetLossThresholdComponent extends DataTypeComponent implements OnInit {
  fg: UntypedFormGroup;
  currencyCode: string;
  playerId: number;
  success: boolean = false;
  updatingInProgress: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private service: PersonalMonthlyNetLossThresholdService,
    private changesDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {}

  override setRowData(entity: any) {
    this.currencyCode = entity?.currencyCode;
    this.playerId = entity.details?.playerId;
    this.initialize();
  }

  private initialize() {
    this.service.get(this.playerId).subscribe((d) => {
      this.fg = this.fb.group({
        disableGlobalAffordability: [d.disableGlobalAffordability, Validators.required],
        active: [d.active, Validators.required],
        value: [this.currencyCode + ' ' + (d.value?.split(' ')[1] || '0.00')],
        freeze: [d.actions?.includes(Action.FREEZE_ACCOUNT)],
        depositBlock: [d.actions?.includes(Action.BLOCK_DEPOSIT)],
      });
      this.changesDetector.detectChanges();
      this.fg.disable();
    });
  }

  update() {
    this.updatingInProgress = true;
    const rawValue = this.fg.getRawValue();
    this.service
      .update(this.playerId, {
        disableGlobalAffordability: rawValue.disableGlobalAffordability,
        active: rawValue.active,
        value: rawValue.value,
        actions: []
          .concat(rawValue.freeze ? [Action.FREEZE_ACCOUNT] : [])
          .concat(rawValue.depositBlock ? [Action.BLOCK_DEPOSIT] : []),
      })
      .subscribe(
        () => {
          this.toggleEditMode();
          this.fg.disable();
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 2000);
          this.updatingInProgress = false;
        },
        () => {
          this.success = false;
          this.updatingInProgress = false;
        }
      );
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.fg.enable();
    } else {
      this.initialize();
    }
  }
}
